import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {WarehouseManagementComponent} from './warehouse-management.component';
import {
  WarehouseManagementDashboardComponent
} from './warehouse-management-dashboard/warehouse-management-dashboard.component';
import {WarehousesListComponent} from './warehouses-list/warehouses-list.component';
import {
  WarehouseBuildingViewComponent
} from "./warehouses-list/warehouse-view/warehouse-building-list/warehouse-building-view/warehouse-building-view.component";
import {
  WarehouseZoneViewComponent
} from "./warehouses-list/warehouse-view/warehouse-zone-list/warehouse-zone-view/warehouse-zone-view.component";
import {WarehouseReportComponent} from "./reports/warehouse-report/warehouse-report.component";
import {ReportsPageComponent} from "./reports/reports-page/reports-page.component";
import { WarehouseSensorBinsComponent } from './warehouses-list/warehouse-view/warehouse-sensor-list/warehouse-sensor-bins/warehouse-sensor-bins.component';
import {ngxPermissionsGuard} from "ngx-permissions";
import { WarehouseViewComponent } from './warehouses-list/warehouse-view/warehouse-view.component';
import { WarehouseSensorViewComponent } from './warehouses-list/warehouse-view/warehouse-sensor-list/warehouse-sensor-view/warehouse-sensor-view.component';

export const routes: Routes = [
  {
    path: '',
    component: WarehouseManagementComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: WarehouseManagementDashboardComponent,
        // canActivate: [ngxPermissionsGuard],
        data: {
          parentTitlePath: null, // this should be matched to path of a route if needed to be child of it
          menu: {title: 'Dashboard', iconType: 'MAT', icon: 'dashboard'},
          permissions: {
            only: ['can_view_dashboard'],
            redirectTo: ['not-allowed']
          },
        }
      },
      // {
      //   path: 'geographical-zones',
      //   component: GeographicalZonesListComponent,
      //   // canActivate: [ngxPermissionsGuard],
      //   data: {
      //     parentTitlePath: null, // this should be matched to path of a route if needed to be child of it
      //     menu: {title: 'Geographical Zones', iconType: 'MAT', icon: 'map'},
      //     isGlobal: false,
      //     permissions: {
      //       only: ['NO_PERMISSION'],
      //       redirectTo: ['not-allowed']
      //     },
      //   }
      // },
      {
        path: 'warehouse-list',
        component: WarehousesListComponent,
        // canActivate: [ngxPermissionsGuard],
        data: {
          parentTitlePath: null, // this should be matched to path of a route if needed to be child of it
          menu: {title: 'Warehouses', iconType: 'MAT', icon: 'warehouse'},
          permissions: {
            only: ['NO_PERMISSION'],
            redirectTo: ['not-allowed']
          },
        },
      },
      {
        path: 'warehouse-list/view/:uniqueId',
        component: WarehouseViewComponent,
        // canActivate: [ngxPermissionsGuard],
        data: {
          parentTitlePath: null, // this should be matched to path of a route if needed to be child of it
          // menu: {title: 'Warehouses', iconType: 'MAT', icon: 'warehouse'},
          permissions: {
            only: ['NO_PERMISSION'],
            redirectTo: ['not-allowed']
          },
        },
      },
      {
        path: 'warehouse-list/building-view/:uniqueId',
        component: WarehouseBuildingViewComponent,
        // canActivate: [ngxPermissionsGuard],
        data: {
          ignore: true,
          permissions: {
            only: ['NO_PERMISSION'],
            redirectTo: ['not-allowed']
          },
        },
      },
      {
        path: 'warehouse-list/zone-view/:uniqueId/:warehouseUID',
        component: WarehouseZoneViewComponent,
        // canActivate: [ngxPermissionsGuard],
        data: {
          ignore: true,
          permissions: {
            only: ['NO_PERMISSION'],
            redirectTo: ['not-allowed']
          },
        },
      },
      {
        path: 'warehouse-list/sensor-bins-mapping',
        component: WarehouseSensorBinsComponent,
        // canActivate: [ngxPermissionsGuard],
        data: {
          ignore: true,
          permissions: {
            only: ['NO_PERMISSION'],
            redirectTo: ['not-allowed']
          },
        },
      },
      {
        path: 'warehouse-list/sensor-view',
        component: WarehouseSensorViewComponent,
        // canActivate: [ngxPermissionsGuard],
        data: {
          ignore: true,
          permissions: {
            only: ['NO_PERMISSION'],
            redirectTo: ['not-allowed']
          },
        },
      },
      // {
      //   path: 'buildings',
      //   component: BuilidingsList,
      //   // canActivate: [ngxPermissionsGuard],
      //   data: {
      //     parentTitlePath: null, // this should be matched to path of a route if needed to be child of it
      //     menu: {title: 'Buildings', iconType: 'MAT', icon: 'location_city'},
      //     isGlobal: false,
      //     permissions: {
      //       only: ['NO_PERMISSION'],
      //       redirectTo: ['not-allowed']
      //     },
      //   }
      // },
      {
        path: 'reports',
        component: ReportsPageComponent,
        // canActivate: [ngxPermissionsGuard],
        data: {
          parentTitlePath: null, // this should be matched to path of a route if needed to be child of it
          menu: {title: 'Reports', iconType: 'MAT', icon: 'summarize'},
          isGlobal: false,
          permissions: {
            only: ['can_generate_report'],
            redirectTo: ['not-allowed']
          },
        }
      },

    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WarehouseManagementRoutingModule {
}
